import React, {Component} from 'react'
import {fillFieldsFromData} from '../../../common/util/util-fields'
import {Field, FieldsManager} from '../../../data/services/fields'
import Resources from '../../../data/services/resources'
import LocalStorage from '../../../util/localStorage'
import {getResource, updateResource} from '../../../data/actions/resource'
import {getSecondResource} from '../../../data/actions/secondResource'
import {LoaderLarge} from "../../../common/components/loader";
import PageFooter from "../../../common/components/layout/layout-components/page/page-footer";
import {UPDATE_PERM} from '../../../util/util-constants'
import {checkPerm, getProp} from '../../../common/util/util-helpers'
import {toFrontDateTimeFromUTC} from "../../../common/util/util-dates";
import DisplayDataGrid from "../../../common/components/display-data/display-data-grid";
import Card from "../../../common/components/card";
import FieldsForm from "../../../common/components/fields/fields-form";
import InfoBar from "../../../common/components/info-paragraph/info-bar";
import FieldOptions from "../../../common/components/fields/field-options";
import {showModal} from "../../../data/actions/ui";
import InformationCircleIcon from "@heroicons/react/24/outline/InformationCircleIcon";
import {formatMoney} from "../../../common/util/util-formaters";
import {TrashIcon} from '@heroicons/react/24/outline'
import {numberWithCommasToBack} from '../../../util/util-formaters'
import ModalConfirm from "../../../common/components/modal/modal-confirm";
import {
    MAX_OFFICE_OVERRIDES,
    officeOverridesFromData,
    officeOverrideValuesFromRows,
    validateOfficeOverrideRows
} from './credit-office-overrides-util'

export default class CustomerCreditTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            fields: this.getFields(),
            creditLimitOffices: [],
            officesMap: {},

            isDirty: false,
            footerIsSticky: true,
            isCreditHoldConfirmDialogOpen: false
        }
    }

    /** Lifecycle
     ================================================================= */
    componentDidMount() {
        this.fetchData()
        this.fetchOffices()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.resource.isLoading && !this.props.resource.isLoading) {
            const data = getProp(this.props.resource, 'data', {});
            this.setState({
                fields: this.getFields(data),
                creditLimitOffices: officeOverridesFromData(data)
            })
        }

        if (prevProps.secondResource?.isLoading && !this.props.secondResource?.isLoading && this.props.secondResource?.resource === Resources.OfficesQuick) {
            this.setState({
                officesMap: getProp(this.props.secondResource, 'data.list', []).reduce((memo, it) => {
                    memo[it.OfficeID] = it.OfficeName;
                    return memo;
                }, {})
            })
        }

        if (prevState.isDirty !== this.state.isDirty) {
            this.props.setIsStateDirty(this.state.isDirty)
        }
    }

    /** Data events
     ================================================================= */
    fetchData = () => {
        this.props.dispatch(getResource({
            user: LocalStorage.get('user'),
            resource: this.getResourceName(),
            query: {
                id: this.getID()
            }
        }))
    }

    fetchOffices = () => {
        this.props.dispatch(getSecondResource({
            user: LocalStorage.get('user'),
            resource: Resources.OfficesQuick,
            query: {
                limit: 100,
                offset: 0
            }
        }))
    }

    onSubmit = () => {
        if (this.state.isDirty) {
            const isCreditLimitSet = !!this.state.fields.SetCreditLimit?.value;

            const validatedOverrides = isCreditLimitSet
                ? validateOfficeOverrideRows(this.state.creditLimitOffices)
                : {rows: this.state.creditLimitOffices, isValid: true};

            this.setState({
                fields: FieldsManager.validateFields(this.state.fields),
                creditLimitOffices: validatedOverrides.rows
            }, () => {
                if (FieldsManager.checkFieldsForErrors(this.state.fields) && validatedOverrides.isValid) {
                    const fieldValues = FieldsManager.getFieldKeyValues(this.state.fields);

                    fieldValues.CreditLimit = fieldValues.SetCreditLimit
                        ? fieldValues.CreditLimit
                        : 0;

                    fieldValues.AllowCreditLimitOverride = fieldValues.SetCreditLimit
                        ? fieldValues.AllowCreditLimitOverride
                        : 0;

                    delete fieldValues.SetCreditLimit;

                    this.props.dispatch(updateResource({
                        user: LocalStorage.get('user'),
                        params: Object.assign(
                            {},
                            fieldValues,
                            officeOverrideValuesFromRows(this.state.creditLimitOffices, isCreditLimitSet),
                            {
                                id: this.getID(),
                            }
                        ),
                        query: {
                            id: this.getID(),
                        },
                        errorMessage: true, successMessage: this.props.translate('text.CustomerSettingsUpdated'),
                        resource: this.getResourceName(),
                        piggyResource: this.getResourceName()
                    }))
                    this.setState({isDirty: false})
                }
            })
        }
    }

    /** UI events
     ================================================================= */

    handleFormCancel = () => {
        const data = getProp(this.props.resource, 'data', {});
        this.setState({
            fields: this.getFields(data),
            creditLimitOffices: officeOverridesFromData(data),
            isDirty: false
        })
    }

    handleInputChange = (name, value) => {
        let isCreditHoldConfirmDialogOpen = false;

        if ("CreditHold" === name) {
            isCreditHoldConfirmDialogOpen = !value
            if (isCreditHoldConfirmDialogOpen) {
                this.setState({
                    isCreditHoldConfirmDialogOpen: true
                })
                value = true;
            }
        }

        const fieldsUpdate = FieldsManager.updateField(this.state.fields, name, value);

        if ("SetCreditLimit" === name) {
            fieldsUpdate.CreditLimit.disabled = !value;
            fieldsUpdate.CreditLimit.validate = !value ? [''] : ['min:1'];
            fieldsUpdate.AllowCreditLimitOverride.disabled = !value;
        }


        fieldsUpdate[name].errorMessage = "";

        this.setState({
            fields: fieldsUpdate,
            isDirty: true
        })
    }

    handleConfirmDisableCreditHold = () => {
        const fieldsUpdate = FieldsManager.updateField(this.state.fields, "CreditHold", false);
        this.setState({
            fields: fieldsUpdate,
            isDirty: true,
            isCreditHoldConfirmDialogOpen: false
        })
    }

    handleOfficeOverrideAdd = () => {
        if (this.state.creditLimitOffices.length >= MAX_OFFICE_OVERRIDES) return;

        this.setState({
            creditLimitOffices: [
                ...this.state.creditLimitOffices,
                {OfficeID: '', OfficeName: '', Amount: '', errorOfficeID: '', errorAmount: ''}
            ],
            isDirty: true
        })
    }

    handleOfficeOverrideDelete = (index) => {
        this.setState({
            creditLimitOffices: this.state.creditLimitOffices.filter((_, i) => i !== index),
            isDirty: true
        })
    }

    handleOfficeOverrideChange = (index, name, value) => {
        const creditLimitOffices = this.state.creditLimitOffices.map((row, i) => {
            if (i !== index) return row;

            if (name === 'CreditLimitOfficeID') {
                return Object.assign({}, row, {
                    OfficeID: value?.value ?? '',
                    OfficeName: value?.label ?? '',
                    errorOfficeID: ''
                });
            }

            return Object.assign({}, row, {Amount: value, errorAmount: ''});
        });

        this.setState({creditLimitOffices, isDirty: true})
    }

    /** Fields/data definitions
     ================================================================= */
    getFields = (data = {}) => {
        const areCreditFieldsDisabled = !data?.CreditLimit;

        let fieldTemplates = {

            SetCreditLimit: new Field('SetCreditLimit', areCreditFieldsDisabled ? 0 : 1, [''], false, 'checkbox', {addContainerClass: "col-span-4"}),
            CreditLimit: new Field('CreditLimit', "", areCreditFieldsDisabled ? [''] : ['min:1'], !!data?.CreditHold || areCreditFieldsDisabled, 'money', {addContainerClass: "col-start-1 col-span-4"}),
            AllowCreditLimitOverride: new Field('AllowCreditLimitOverride', '', [''], areCreditFieldsDisabled, 'checkbox', {
                addContainerClass: "col-span-4"
            }),
            AllowOnlyOneUnpaidInvoice: new Field('AllowOnlyOneUnpaidInvoice', '', [''], false, 'checkbox', {
                addContainerClass: "col-span-full"
            }),
            CreditHold: new Field('CreditHold', '', [''], false, 'checkbox', {
                labelType: "float",
                addContainerClass: "col-span-full"
            }),
            CreditHoldNote: new Field('CreditHoldNote', '', [''], false, 'textarea', {addContainerClass: "col-span-full"}),
            Rating: new Field('Rating', '', [''], false, '', {addContainerClass: "col-span-full"}),
            Agency: new Field('Agency', '', [''], false, '', {addContainerClass: "col-span-full"}),
        }

        if (data?.CreditLimit) {
            data = Object.assign({}, data, {CreditLimit: formatMoney(numberWithCommasToBack(data.CreditLimit))});
        }

        return fillFieldsFromData(fieldTemplates, data);
    }

    getCreditUpdateFields = (data = {}) => {
        let fieldTemplates = {
            CreditLimitUpdateDate: new Field('CreditLimitUpdateDate', '', [''], false, 'datetimezone', {hideDialog: true}, {addContainerClass: "col-span-full"}),
            CreditLimitUpdateBy: new Field('CreditLimitUpdateBy', '', [''], false, 'text', {
                hideDialog: true,
                options: () => (
                    <FieldOptions
                        options={[
                            {
                                icon: InformationCircleIcon,
                                onClick: () => this.props.dispatch(showModal('ViewContactCard', {ContactID: data?.CreditLimitUpdateByID ?? 0})),
                                isVisible: true
                            }
                        ]}
                    />
                )
            })
        }

        return fillFieldsFromData(fieldTemplates, data);
    }

    getOfficeOverrideRowFields = (row) => {
        const officeValue = row.OfficeID
            ? {value: row.OfficeID, label: row.OfficeName || this.state.officesMap[row.OfficeID] || ''}
            : null;

        const fields = {
            CreditLimitOfficeID: new Field('CreditLimitOfficeID', officeValue, [''], false, 'select-search', {
                label: 'OfficeID',
                addContainerClass: 'col-span-6'
            }),
            CreditLimitOffice: new Field('CreditLimitOffice', row.Amount, [''], false, 'money', {
                label: 'CreditLimit',
                addContainerClass: 'col-span-6'
            })
        };

        fields.CreditLimitOfficeID.errorMessage = row.errorOfficeID || null;
        fields.CreditLimitOffice.errorMessage = row.errorAmount || null;

        return fields;
    }

    getOfficeOverrideSelects = (rowIndex) => {
        const usedOfficeIDs = this.state.creditLimitOffices
            .filter((_, i) => i !== rowIndex)
            .map(it => it.OfficeID)
            .filter(Boolean);

        return {
            CreditLimitOfficeID: {
                api: 'api/' + Resources.OfficesQuick,
                query: {limit: 10, offset: 0},
                customizeList: (list) => list
                    .filter(it => !usedOfficeIDs.includes(it.OfficeID))
                    .map(it => ({label: it.OfficeName, value: it.OfficeID}))
            }
        };
    }

    /** Helpers
     ================================================================= */
    getResourceName = () => {
        return Resources.CustomersCredit
    }

    getID = () => {
        return this.props.match.params.CustomerID
    }

    /** Render
     ================================================================= */
    render() {
        const {translate, resource} = this.props;
        const {data, isLoading} = this.props.resource;
        // const fieldsHTML = fieldsToHtml(Object.values(Object.assign({}, this.state.fields)), translate, this.handleInputChange, {})

        return (
            <div className="max-w-4xl mx-auto">
                <Card className="bg-inverse rounded-card border-tm-gray-300 border shadow-card mb-4 relative pb-6">
                    <div className={'grid grid-cols-12 gap-4'}>
                        <p className="col-span-full font-bold text-tm-gray-700">
                            {translate('text.CreditHold')}
                        </p>

                        <FieldsForm
                            fieldsState={this.state.fields}
                            includeFields={['CreditHold']}
                            onChange={this.handleInputChange}
                            isLoading={isLoading}
                            translate={translate}
                        />

                        {this.state.fields?.CreditHold?.value && (
                            <InfoBar addClass="col-span-full text-base" type="danger">
                                <div className="max-w-lg">
                                    The creation of loads is not possible when the credit hold check is enabled. Loads
                                    that are already created will have an additional warning on the load pricing page,
                                    but they can be completed as they are.
                                </div>
                            </InfoBar>
                        )}

                        <div className="col-span-full border-t border-tm-gray-300"/>

                        <p className="col-span-full font-bold text-tm-gray-700">
                            {translate('text.CreditLimit')}
                        </p>

                        <FieldsForm
                            fieldsState={this.state.fields}
                            includeFields={['SetCreditLimit', 'CreditLimit', 'AllowCreditLimitOverride']}
                            onChange={this.handleInputChange}
                            isLoading={isLoading}
                            translate={translate}
                        />

                        {!!this.state.fields?.SetCreditLimit?.value && (
                            <div className="col-span-full space-y-4">
                                <p className="text-sm font-medium text-tm-gray-600">
                                    {translate('text.credit_limit_office_overrides')}
                                </p>

                                {this.state.creditLimitOffices.map((row, i) => (
                                    <div key={i} className="flex items-center gap-4">
                                        <div className="grid grid-cols-12 gap-4 grow">
                                            <FieldsForm
                                                fieldsState={this.getOfficeOverrideRowFields(row)}
                                                selects={this.getOfficeOverrideSelects(i)}
                                                onChange={(name, value) => this.handleOfficeOverrideChange(i, name, value)}
                                                translate={translate}
                                            />
                                        </div>

                                        <button
                                            type="button"
                                            className="btn btn-icon"
                                            title={translate('btn.delete')}
                                            onClick={() => this.handleOfficeOverrideDelete(i)}
                                        >
                                            <TrashIcon className="w-5 h-5"/>
                                        </button>
                                    </div>
                                ))}

                                {this.state.creditLimitOffices.length < MAX_OFFICE_OVERRIDES && (
                                    <button
                                        type="button"
                                        className="btn btn-outline"
                                        onClick={this.handleOfficeOverrideAdd}
                                    >
                                        {translate('btn.add_office_override')}
                                    </button>
                                )}
                            </div>
                        )}

                        <div className="col-span-full border-t border-tm-gray-300"/>

                        <p className="col-span-full font-bold text-tm-gray-700">
                            {translate('text.Other')}
                        </p>

                        <FieldsForm
                            fieldsState={this.state.fields}
                            includeFields={['AllowOnlyOneUnpaidInvoice']}
                            onChange={this.handleInputChange}
                            isLoading={isLoading}
                            translate={translate}
                        />

                        <div className="col-span-full border-t border-tm-gray-300"/>

                        <p className="col-span-full font-bold text-tm-gray-700">
                            {translate('text.Info')}
                        </p>

                        <FieldsForm
                            fieldsState={this.state.fields}
                            includeFields={['CreditHoldNote', 'Rating', 'Agency']}
                            onChange={this.handleInputChange}
                            isLoading={isLoading}
                            translate={translate}
                        />

                        {!!getProp(this.props.resource, 'data.CreditLimitUpdateByID', 0) && (
                            <DisplayDataGrid
                                addGridClass={"col-span-full grid-cols-2 border border-tm-gray-300 rounded-lg p-5 text-tm-gray-700 font-bold"}
                                displayList={Object.values(this.getCreditUpdateFields(data)).filter(it => it.name === 'CreditLimitUpdateDate' || it.name === 'CreditLimitUpdateBy')}
                                data={{
                                    CreditLimitUpdateBy: getProp(this.props.resource, "data.CreditLimitUpdateBy", ''),
                                    CreditLimitUpdateDate: toFrontDateTimeFromUTC(getProp(this.props.resource, "data.CreditLimitUpdateDate", ''))
                                }}
                                translate={translate}
                            />
                        )}
                    </div>

                    {!!resource.isLoading && (
                        <LoaderLarge/>
                    )}
                </Card>

                <PageFooter
                    translate={translate}
                    canSubmit={this.state.isDirty}
                    actionCancel={this.handleFormCancel}
                    actionSubmit={checkPerm(this.getResourceName(), UPDATE_PERM) && this.onSubmit}
                />

                <ModalConfirm
                    title={'Confirm'}
                    show={this.state.isCreditHoldConfirmDialogOpen}
                    onClose={() => this.setState({
                        isCreditHoldConfirmDialogOpen: false
                    })}
                    buttonLabel={translate('btn.confirm')}
                    closeButtonLabel={'Cancel'}
                    translate={translate}
                    onConfirm={this.handleConfirmDisableCreditHold}
                >
                    <div className="text-base">
                        {translate("text.confirm_credit_on_hold_disable")}
                    </div>
                </ModalConfirm>
            </div>
        )
    }
}
